import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  VStack,
} from '@chakra-ui/react'

import { PURCHASE_SCENARIO_OPTIONS } from '@/features/GCMaterials/constants/purchaseScenarioOptions'
import { useFillPONumberModalManagement } from '@/stores/ui/fillPONumberModalSlice'

const FillPONumberModal = () => {
  const { isOpened, title, inputLabel, vendorOptions, confirm, decline } = useFillPONumberModalManagement()
  const inputRef = useRef(null)
  const [selectedPurchaseScenarios, setSelectedPurchaseScenarios] = useState(['PTO'])
  const [selectedVendors, setSelectedVendors] = useState([])

  useEffect(() => {
    if (isOpened) {
      setSelectedPurchaseScenarios(['PTO'])
      setSelectedVendors(vendorOptions)
    }
  }, [isOpened, vendorOptions])

  const handleTogglePurchaseScenario = (value) => {
    setSelectedPurchaseScenarios((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    )
  }

  const handleToggleVendor = (value) => {
    setSelectedVendors((prev) => (prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]))
  }

  const handleConfirm = () => {
    confirm({
      inputValue: inputRef?.current?.value ?? '',
      selectedPurchaseScenarios,
      selectedVendors,
    })
  }

  return (
    <Modal isOpen={isOpened} onClose={decline} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>{inputLabel}</FormLabel>
            <Input ref={inputRef} placeholder="Enter PO number" autoFocus />
          </FormControl>
          <FormControl mt="4">
            <FormLabel>Purchase Scenario</FormLabel>
            <VStack align="start" spacing="2">
              {PURCHASE_SCENARIO_OPTIONS.map((purchaseScenario) => (
                <Checkbox
                  key={purchaseScenario}
                  isChecked={selectedPurchaseScenarios.includes(purchaseScenario)}
                  onChange={() => handleTogglePurchaseScenario(purchaseScenario)}
                >
                  {purchaseScenario}
                </Checkbox>
              ))}
            </VStack>
          </FormControl>
          {vendorOptions.length > 0 && (
            <FormControl mt="4">
              <FormLabel>Vendor</FormLabel>
              <VStack align="start" spacing="2">
                {vendorOptions.map((vendor) => (
                  <Checkbox
                    key={vendor}
                    isChecked={selectedVendors.includes(vendor)}
                    onChange={() => handleToggleVendor(vendor)}
                  >
                    {vendor}
                  </Checkbox>
                ))}
              </VStack>
            </FormControl>
          )}
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button colorScheme="teal" onClick={handleConfirm}>
              Confirm
            </Button>
            <Button colorScheme="gray" onClick={decline}>
              Cancel
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default FillPONumberModal
